import { Mutations } from '../mutations/agents-mutations';
import { Actions } from '../actions/agents-actions';
import { Getters } from '../getters/agents-getters';

export const initialState = {
  tablePagination: {
    sortBy: 'name',
    descending: false,
  },
  actionMenu: {},
  agentsList: [],
  agentsLocked: {},
  agentsUpdating: {},
  logLevels: ['Minimal', 'Basic', 'Intermediate', 'Extended', 'Detailed'],
  filtersGQL: {
    agentGQLFilters: {},
    quickFilter: '',
    sort: {
      field: '',
      order: '',
    },
    searchFilter: '',
    paging: {
      pageSize: 0,
      pageNumber: 0,
    },
  },
  agentBulkMenuVisible: false,
};

export default {
  namespaced: true, // set to true in case we wish to use multiple modules at the same time
  state: initialState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};
